export const CLIENT_CARE_LETTER_SECTIONS = [
  {
    key: "Introduction",
    value: [
      "This letter sets out what you have asked Squiggle Consult Ltd (\"Squiggle\", \"we\", \"us\") to do for you, what it will cost and how we will work together. Please read it with the Terms of Engagement at the back of this booklet.",
      "Your contract is with Squiggle Consult Ltd. Your Consultant acts for us, and we are responsible for the advice they give you and for the work we do."
    ]
  },
  {
    key: "Your Consultants obligations to you and how you have arrived at your Legacy and Estate Planning decision",
    isHeadingBold: true,
    value: [
      "Your Consultant will have asked about your family, your finances and what you want to happen. They will have explained the options that fit your situation: what each one can and cannot do, what it costs, and what happens if you do nothing. They will have told you what they recommend and why.",
      "The decision is yours. What you have chosen is recorded on the instruction page of this letter."
    ]
  },
  {
    key: "Your obligations to your Consultant",
    isHeadingBold: true,
    value: [
      "Please give us full and accurate information, tell us if anything changes, and check your draft documents carefully when we send them. Section 3 of the Terms of Engagement explains this."
    ]
  },
  {
    key: "Consultation limitations",
    isHeadingBold: true,
    value: [
      "We will explain how inheritance tax may affect your estate and how the documents we prepare deal with it. We do not give regulated financial advice, for example on investments, pensions or insurance, and we do not prepare tax returns.",
      "If your situation needs specialist tax or financial advice, we will tell you and can introduce you to someone suitable."
    ]
  },
  {
    key: "Who will be working for you?",
    isHeadingBold: true,
    value: [
      "Your Consultant is your main point of contact from start to finish.",
      "Squiggle is a specialist estate planning firm. Members of our team belong to the Society of Will Writers, the BEST Foundation and CILEX and follow their codes of conduct. We hold professional indemnity insurance of £5 million and you are welcome to see a copy. We are not a firm of solicitors, and will writing and estate planning are not regulated activities in England and Wales.",
      "Your documents are prepared by Squiggle's own team and checked before we send them to you. Where the law says a piece of work can only be done by a regulated law firm, or where we think your situation calls for it, we use one of the firms named in our pre-contract information and we will tell you which one. It does not change your fee, and we stay your point of contact throughout.",
      "Other organisations may be involved, such as the Office of the Public Guardian, HM Land Registry, the National Will Register and our document storage provider."
    ]
  },
  {
    key: "Fees & Charges",
    isHeadingBold: true,
    value: [
      "Your fee is fixed, includes VAT, and is shown on the instruction page. It covers preparing your documents and the work of any law firm we use.",
      "Fees we pay to others for you, such as registration fees charged by the Office of the Public Guardian or HM Land Registry, are shown separately on the same page and passed on at cost.",
      "We will not ask you for anything more unless one of the charges in the \"Other charges\" table in section 1 of the Terms of Engagement applies, or you ask for extra work and we agree a price with you first."
    ]
  },
  {
    key: "Confidentiality and Your Information",
    isHeadingBold: true,
    value: [
      "We keep your information confidential and handle it in line with UK data protection law.",
      "To do the work you have asked for, we share what is needed with the organisations involved in your plan: the law firms we use, the Office of the Public Guardian, HM Land Registry, the National Will Register and our document storage provider. We do not sell your information or pass it on for marketing without your consent.",
      "We use AI tools to help our team with the work, for example drafting, checking and note-taking. They run on business accounts, where the provider is not allowed to use your information to train its systems. Our team must check anything a tool produces before it goes into your documents, and a person makes every decision about you and your family. If a meeting is going to be transcribed, we will tell you at the start and you can ask us to take notes by hand instead.",
      "Our Privacy Notice at squiggleconsult.co.uk/privacy-notice explains what we hold, how long we keep it and your rights."
    ]
  },
  {
    key: "Should you decide to cancel",
    isHeadingBold: true,
    value: [
      "You can cancel within 14 days without giving a reason. The 14 days start the day after you sign this letter. Tell us by email, phone or letter, or use the cancellation form at the end of the Terms of Engagement. We will refund what you have paid within 14 days of you telling us.",
      "We will not start work during the 14 days unless you ask us to on the declaration page. If you ask us to start and then cancel within the 14 days, you pay only for the work done up to that point.",
      "Section 8 of the Terms of Engagement explains this, and what happens if you want to stop after the 14 days."
    ]
  },
  {
    key: "Should you have cause to complain",
    isHeadingBold: true,
    value: [
      "Please tell us, so we can put it right. You can speak to your Consultant, or contact Kieran Osborne, Managing Director, at kieran.osborne@squiggleconsult.co.uk or on 01233 659796.",
      "We will acknowledge your complaint within 5 working days and give you a full written response within 28 days.",
      "If you are still unhappy, you can refer your complaint to the Society of Will Writers or the BEST Foundation, depending on which body your Consultant belongs to. Our final response will tell you which applies and how to contact them. Because we are not a firm of solicitors, the Legal Ombudsman does not deal with complaints about Squiggle. Section 11 of the Terms of Engagement has the full procedure."
    ]
  }
];

export const OTHER_CHARGES = [
  {
    charge: "Changes before your documents are stored",
    whenItApplies: "You change your mind after we have sent your final documents but before your signed documents have gone into storage (section 4.2)",
    amount: "£15 per document, plus any third-party fee for a new application"
  },
  {
    charge: "Changes after your documents are stored",
    whenItApplies: "You want to change a document after it has been signed and stored, or sent to you if you asked us not to store it (section 4.2)",
    amount: "£100 per document, plus any third-party fee for a new application. Not charged where a LegacyGuard plan covers the change"
  },
  {
    charge: "Correcting details in a draft you approved",
    whenItApplies: "A name, date or other detail was wrong in a draft you approved, and this is found later (section 4.3)",
    amount: "10% of our price for that document, plus any third-party fee for a new application"
  },
  {
    charge: "Re-issuing documents signed incorrectly",
    whenItApplies: "Your documents have been signed incorrectly twice because the signing instructions were not followed (section 2.4)",
    amount: "£15 per document for each further re-issue"
  },
  {
    charge: "Reopening a closed file",
    whenItApplies: "We closed your file because we had not heard from you for six months (section 5.2), and you ask us to carry on (section 5.4)",
    amount: "10% of your original fee, plus any increase in third-party fees"
  },
  {
    charge: "Retrieving originals from storage",
    whenItApplies: "You or your representatives ask for stored originals (section 9.3)",
    amount: "Currently £50 per request, plus any extra cost of delivery outside the UK"
  },
  {
    charge: "Sending originals to you instead of storing them",
    whenItApplies: "You ask us not to store your original documents and to send them to you instead (section 9.1)",
    amount: "The retrieval fee, currently £50, plus any extra cost of delivery outside the UK"
  },
  {
    charge: "Courier and overseas post",
    whenItApplies: "You ask us to send something by courier or special delivery that we would normally send by standard post, for example unsigned documents for signing, or we need to send other documents to an address outside the UK",
    amount: "At cost. We will tell you the amount before we send them"
  },
  {
    charge: "Stepping aside as executor",
    whenItApplies: "Your family ask us to renounce (section 1.6)",
    amount: "£250, which includes preparing the renunciation form"
  }
];

export const FEES_CLAUSES = [
  {
    number: "1.3",
    text: "We never charge for putting right our own mistakes (section 2.10)."
  },
  {
    number: "1.4",
    text: "Professional executor services. If you appoint Squiggle Consult Ltd as an executor in your Will, there is nothing to pay now, and Squiggle Consult Ltd does not charge a fee for being your executor. After your death we will appoint Squiggle Probate Ltd to carry out the work of dealing with your estate. Its fees are paid from your estate, not by you."
  },
  {
    number: "1.5",
    text: "We cannot give a price today, because the fee depends on the size and complexity of your estate when the time comes. Squiggle Probate Ltd's prices at the date of your death will apply. As a guide, its current charge for dealing with a whole estate is 2% of the gross value of the estate (its value before any debts are taken off), plus VAT and third-party costs. Before any work starts, it will give your family a written quote."
  },
  {
    number: "1.6",
    text: "If your family would rather deal with the estate themselves or use another firm, we will step aside, as long as the estate and the people who inherit would not be worse off. Stepping aside is done by signing a formal renunciation. We charge £250 for this, which includes preparing the form. We may not be able to step aside once work has started."
  }
];

export const TERMS_SECTIONS = [
  {
    heading: "2. Squiggles' and its consultants' undertaking",
    clauses: [
      {
        number: "2.1",
        paragraphs: [
          "We will find out enough about your circumstances and wishes to advise you properly, and we will carry out our work with reasonable care and skill."
        ]
      },
      {
        number: "2.2",
        paragraphs: [
          "Most of our work is done by our own team. Where the law says a piece of work can only be done by a regulated law firm, or where we think your situation calls for it, we use one of the firms named in our pre-contract information and we will tell you which firm. It does not change your fee."
        ]
      },
      {
        number: "2.3",
        paragraphs: [
          "You do not have to take up anything we recommend. If you decide not to follow our advice, we will note that on your file so there is a clear record of what was discussed."
        ]
      },
      {
        number: "2.4",
        paragraphs: [
          "Signing your documents. A Will or Lasting Power of Attorney that is signed incorrectly may not be valid. We will always give you written signing instructions. Your Consultant can also go through them with you, and if you live near one of our Consultants we can offer a signing appointment at no charge. When you return your signed documents we will check them. If they have been signed incorrectly we will re-issue them once free of charge. If they are signed incorrectly a second time because the instructions were not followed, further re-issues are charged as shown in section 1.2. We never charge where the mistake was caused by us."
        ]
      },
      {
        number: "2.5",
        paragraphs: [
          "Our advice is based on the law at the date we give it. We are not responsible for the effect of later changes in the law, so please review your plan every few years or when your circumstances change."
        ]
      },
      {
        number: "2.6",
        paragraphs: [
          "We hold professional indemnity insurance of £5 million. You can ask to see the certificate."
        ]
      },
      {
        number: "2.7",
        paragraphs: [
          "The regulated law firms we use hold their own insurance, as their regulators require."
        ]
      },
      {
        number: "2.8",
        paragraphs: [
          "You pay Squiggle, unless we tell you in writing to pay a law firm direct."
        ]
      },
      {
        number: "2.9",
        paragraphs: [
          "If we find we cannot complete your work, we will tell you in writing straight away and refund what you have paid for work we have not done. Third-party fees already paid for you with your agreement cannot be refunded."
        ]
      },
      {
        number: "2.10",
        paragraphs: [
          "We put right our own errors and omissions at our own cost."
        ]
      }
    ]
  },
  {
    heading: "3. Your Obligations",
    clauses: [
      {
        number: "3.1",
        paragraphs: [
          "Our documents rely on what you tell us. Please give us full and accurate information, and tell us if anything changes before your documents are signed."
        ]
      },
      {
        number: "3.2",
        paragraphs: [
          "We will send you drafts to check. Please check names, dates of birth, addresses and the people you have appointed carefully, and tell us about anything that is wrong before you approve them."
        ]
      },
      {
        number: "3.3",
        paragraphs: [
          "We are not responsible for problems caused by information that was wrong or incomplete when you gave it to us, unless we should have spotted the problem from what we already held on your file. For names, dates and other details in drafts you have approved, section 4.3 applies."
        ]
      },
      {
        number: "3.4",
        paragraphs: [
          "We may need to check your identity before we start work, and again if your file is reopened."
        ]
      },
      {
        number: "3.5",
        paragraphs: [
          "Using AI yourself. We use AI in our own work and we are happy for you to use it too. It can be a good way to get your thoughts in order or work out what to ask us. Two things help us help you: tell us at the top, in a sentence or two, what you want to know or want us to do, and send us the question, not the whole conversation."
        ]
      },
      {
        number: "3.6",
        paragraphs: [
          "How we reply. Your fee covers the normal back and forth needed to complete your documents. We reply to the points that matter to your instructions, not line by line, and if a call is quicker we will suggest one. If you would like us to review a long document or a set of AI answers in detail, we can, and we will agree a price with you first."
        ]
      },
      {
        number: "3.7",
        paragraphs: [
          "A word of caution. AI tools do not know your circumstances and can be wrong about the law in England and Wales. If one tells you something different from what we have advised, ask us and we will explain. Free AI tools may keep what you type in, so think before you paste in personal documents."
        ]
      },
      {
        number: "3.8",
        paragraphs: [
          "None of this affects how we handle complaints or requests about your personal information. We deal with those in the usual way, however they are written."
        ]
      }
    ]
  },
  {
    heading: "4. Amendments to Documents",
    clauses: [
      {
        number: "4.1",
        paragraphs: [
          "Changes you ask for before we send your final documents are free."
        ]
      },
      {
        number: "4.2",
        paragraphs: [
          "If you change your mind after we have sent your final documents but before your signed documents have gone into storage, we charge £15 per document to re-issue them. Once your signed documents have been stored, or sent to you if you asked us not to store them, changes cost £100 per document, whenever you come back to us. This charge does not apply to changes covered by a LegacyGuard plan, if you have one. In either case, if the change means a new application to a third party, for example registering a Lasting Power of Attorney again, their fee is payable as well."
        ]
      },
      {
        number: "4.3",
        paragraphs: [
          "Mistakes found later, for example after a Lasting Power of Attorney has been registered. We send you drafts so that you can check every detail before anything is signed or registered. The details in the drafts you approve are the ones we rely on, even where they differ from other information we hold, because documents such as ID can themselves be wrong or out of date.",
          "If a name, date of birth, address or other detail was wrong in a draft you approved, you will need to pay the correction charge in section 1.2 and any third-party fee for a new application.",
          "It is our mistake if the final document does not match the draft you approved, if the document does not do what you asked for, or if you asked for a correction and we did not make it. We put these right at our cost, including any registration fee."
        ]
      },
      {
        number: "4.4",
        paragraphs: [
          "Lifetime trusts. A lifetime trust usually cannot be re-issued once it has been signed. It has to be changed by a separate deed. If the change is needed because of information you gave us, or because you have changed your mind, we will give you a price for the deed before we do anything. If the mistake was ours, we pay for the deed."
        ]
      }
    ]
  },
  {
    heading: "5. Timescales",
    clauses: [
      {
        number: "5.1",
        paragraphs: [
          "We aim to send your draft documents within 18 working days of receiving all the information we need and your payment. Some steps are outside our control, such as registration by the Office of the Public Guardian. If anything is going to take longer than expected, we will tell you."
        ]
      },
      {
        number: "5.2",
        paragraphs: [
          "If we do not hear from you (dormant files). If we need information, your approval of drafts or signed documents, we will try to reach you by phone, email and letter. If six months pass without a reply, we will write to tell you that we plan to close your file. If we have not heard from you within 14 days of that letter, we will close it."
        ]
      },
      {
        number: "5.3",
        paragraphs: [
          "When we close a file, we will refund any third-party fees we have not yet paid out and any part of our fee for work we have not done. We keep the part of our fee that covers work already done, and we will tell you in writing what we have kept and why."
        ]
      },
      {
        number: "5.4",
        paragraphs: [
          "Reopening a file. You can ask us to carry on at any time. Before we do, we will need to check your identity, your circumstances and your wishes again, and update your documents for any changes in the law. The reopening charge in section 1.2 covers this. You will also need to pay back anything we refunded when the file was closed. If your wishes have changed so much that new documents are needed, we will give you a price for that first."
        ]
      }
    ]
  },
  {
    heading: "6. Payments",
    clauses: [
      {
        number: "6.1",
        paragraphs: [
          "Payment is due when you confirm your instructions, unless we have agreed instalments with you in writing. We release your final documents once we have been paid in full."
        ]
      },
      {
        number: "6.2",
        paragraphs: [
          "You can pay by bank transfer, debit or credit card, Klarna, PayPal or cheque (payable to Squiggle Consult Ltd). We do not charge extra for any payment method."
        ]
      },
      {
        number: "6.3",
        paragraphs: [
          "We sometimes pay a fee to the person or organisation who introduced you to us, and we may receive a fee if we introduce you to another provider. This does not change what you pay. Ask us and we will give you the details."
        ]
      }
    ]
  },
  {
    heading: "7. Disclosure of Information & Confidentiality",
    clauses: [
      {
        number: "7.1",
        paragraphs: [
          "We keep your information confidential and handle it in line with the UK GDPR and the Data Protection Act 2018. We share it only as explained in your Client Care Letter and our Privacy Notice, or where the law requires us to."
        ]
      },
      {
        number: "7.2",
        paragraphs: [
          "If you instruct us together with a spouse or partner, we will treat information either of you gives us as shared between you, unless you tell us otherwise. If your interests come into conflict, we may have to stop acting for one or both of you."
        ]
      }
    ]
  },
  {
    heading: "8. Cancellation Policy",
    clauses: [
      {
        number: "8.1",
        paragraphs: [
          "You can cancel this agreement within 14 days without giving a reason. The 14 days start the day after you sign your Client Care Letter."
        ]
      },
      {
        number: "8.2",
        paragraphs: [
          "To cancel, tell us clearly by email, phone or letter. You can use the cancellation form at the end of these terms, but you do not have to. We will refund what you have paid within 14 days of you telling us, using the same payment method."
        ]
      },
      {
        number: "8.3",
        paragraphs: [
          "We will not start work during the 14 days unless you ask us to in writing. If you ask us to start and then cancel within the 14 days, you pay for the work we have done up to that point, as a fair proportion of your fee. If we have fully completed the work within the 14 days at your request, you can no longer cancel."
        ]
      },
      {
        number: "8.4",
        paragraphs: [
          "After the 14 days you can still stop at any time before the work is finished. We will refund any third-party fees we have not yet paid out and any part of our fee for work we have not done. By this stage most of the work has usually been done."
        ]
      },
      {
        number: "8.5",
        paragraphs: [
          "Urgent work. Where work has to be done quickly, for example because someone is seriously ill, we do most of it straight away at your request. That usually means there is little or nothing to refund beyond third-party fees we have not yet paid out."
        ]
      },
      {
        number: "8.6",
        paragraphs: [
          "If you die, or can no longer make your own decisions, before your documents are signed. Our work for you stops. We keep the part of our fee that covers the work done up to then, and refund the rest, with any third-party fees we have not yet paid out, to you or your estate. Where the work was urgent, most of it has usually been done, so there may be little or nothing to refund. If you instructed us together with a spouse or partner, we carry on with their documents and will talk to them about what they now need."
        ]
      }
    ]
  },
  {
    heading: "9. Document Storage",
    clauses: [
      {
        number: "9.1",
        paragraphs: [
          "Storing your original documents is included in your fee, and it is what we do unless you tell us otherwise. This covers your Will and, once they are registered, your Lasting Powers of Attorney. You do not have to use our storage. You can keep your documents yourself, or store a Will with the Probate Service. If you would rather we sent your originals to you, the retrieval fee in section 9.3 applies."
        ]
      },
      {
        number: "9.2",
        paragraphs: [
          "Your original documents are held for us in secure storage by our storage provider, currently Restore. There is no separate charge for storage."
        ]
      },
      {
        number: "9.3",
        paragraphs: [
          "You can ask for your originals back at any time. So can your executors or attorneys, once we have checked who they are. We charge a fee to cover retrieval and tracked delivery, currently £50 per request. If they are going to an address outside the UK, you also pay the difference between our usual UK delivery cost and the cost of overseas delivery. Because documents can be stored for many years, this fee may change to reflect our costs. The current fee is shown at squiggleconsult.co.uk/document-retrieval and we will always confirm it before you pay."
        ]
      },
      {
        number: "9.4",
        paragraphs: [
          "If Squiggle ever stops trading, your documents stay in secure storage. We, or the firm that takes over from us, will write to you at the last address we hold to tell you where they are and how to get them back. Your Will is also registered with the National Will Register, which records where it is kept."
        ]
      },
      {
        number: "9.5",
        paragraphs: [
          "We keep an electronic copy of your documents and your file. Our Privacy Notice explains how long we keep them and your rights over your information."
        ]
      }
    ]
  },
  {
    heading: "10. Right Not to Act",
    clauses: [
      {
        number: "10.1",
        paragraphs: [
          "We may decline to act, or stop acting, if there is a conflict of interest, if we do not receive information we need, if payment is not made when due, if we have concerns that the instructions are not your own free wishes, or if we do not think we are the right fit for what you need. We will explain why in writing and refund any payment for work we have not done."
        ]
      }
    ]
  },
  {
    heading: "11. Client Care / Complaints Procedure",
    clauses: [
      {
        number: "11.1",
        paragraphs: [
          "If you are unhappy with any part of our service, please contact Kieran Osborne, Managing Director, at kieran.osborne@squiggleconsult.co.uk, on 01233 659796, or at 11 Park Barn, Station Road, Evegate Business Park, Ashford, Kent, TN25 6SX."
        ]
      },
      {
        number: "11.2",
        paragraphs: [
          "We will acknowledge your complaint within 5 working days and give you a full written response within 28 days of receiving it."
        ]
      },
      {
        number: "11.3",
        paragraphs: [
          "If you are still unhappy, you can refer your complaint to the Society of Will Writers or the BEST Foundation, depending on which body your Consultant belongs to. Our final response will tell you which applies and how to contact them. Because we are not a firm of solicitors, the Legal Ombudsman does not deal with complaints about Squiggle. You also keep your right to go to court."
        ]
      },
      {
        number: "11.4",
        paragraphs: [
          "If your complaint is about how we have handled your personal information, you can also complain to the Information Commissioner's Office."
        ]
      }
    ]
  },
  {
    heading: "12. Force Majeure",
    clauses: [
      {
        number: "12.1",
        paragraphs: [
          "We are not responsible for delays caused by events outside our reasonable control. If that happens we will tell you. If the delay is a long one, you can cancel and we will refund any payment for work we have not done."
        ]
      }
    ]
  },
  {
    heading: "13. Legal Notice",
    clauses: [
      {
        number: "13.1",
        paragraphs: [
          "If a court decides that part of these terms cannot be enforced, the rest still applies."
        ]
      },
      {
        number: "13.2",
        paragraphs: [
          "We will not change the terms that apply to work you have already instructed unless you agree."
        ]
      },
      {
        number: "13.3",
        paragraphs: [
          "Nothing in these terms takes away your legal rights as a consumer, including your right to have our services carried out with reasonable care and skill."
        ]
      }
    ]
  },
  {
    heading: "14. Third Party Liability",
    clauses: [
      {
        number: "14.1",
        paragraphs: [
          "This agreement is between you and Squiggle. Nobody else can enforce it. This does not affect any rights the law gives to other people."
        ]
      }
    ]
  }
];
